var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0883 4.40949L15.5892 1.91116C15.5119 1.83362 15.4201 1.77213 15.319 1.73023C15.2178 1.68833 15.1094 1.66683 15 1.66699H4.99999C4.89054 1.66683 4.78214 1.68833 4.68102 1.73023C4.57991 1.77213 4.48808 1.83362 4.41083 1.91116L1.91166 4.40949C1.8338 4.48672 1.77205 4.57864 1.72999 4.67992C1.68793 4.7812 1.66641 4.88983 1.66666 4.99949V15.8337C1.66666 16.7528 2.41416 17.5003 3.33333 17.5003H16.6667C17.5858 17.5003 18.3333 16.7528 18.3333 15.8337V4.99949C18.3336 4.88983 18.312 4.7812 18.27 4.67992C18.2279 4.57864 18.1662 4.48672 18.0883 4.40949ZM5.34499 3.33366H14.655L15.4875 4.16616H4.51249L5.34499 3.33366ZM3.33333 15.8337V5.83283H16.6667L16.6683 15.8337H3.33333Z",
    fill: "#798495"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.99967H7.50001V8.33301H5.83334V11.6663H14.1667V8.33301H12.5V9.99967Z",
    fill: "#798495"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.a126772e749986223879a03412ecb5e2.svg";
export { ForwardRef as ReactComponent };